export const aiList = [
  {
    activityName: "2026“智领未来”AI提示词工程（Prompt）就业实战营",
    baseRemark:
      "本次实战营旨在帮助应届毕业生和职场新人掌握核心AIGC工具。课程涵盖主流大模型的高级指令编写、AI辅助编程及AI办公自动化流设计。通过三天封闭式训练，学员将完成5个行业真实案例，并在结营时获得知名科技企业内推机会，助力在AI时代实现高质量就业。",
    activityId: "99991",
    catalogueId: "9999",
    catalogueName: "AI·数字智能",
    planNum: "150",
    registerNum: "0",
    registerEndDateStr: "2026年05月25日",
    coverImg:
      "https://file.jycyfww.com/wangchuang/qc/prod/static/img/d5aaa30a72344d5fa64a2106646d9abc.png",
    customModels: [
      {
        key: "报名时间：",
        value: "2026年05月01日 - 2026年05月25日",
      },
      {
        key: "举办时间：",
        value: "2026年05月28日 - 2026年05月30日",
      },
      {
        key: "地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：",
        value: "北京市海淀区佰能大厦2层",
      },
      {
        key: "联系电话：",
        value: "010-82696524",
      },
      {
        key: "计划人数：",
        value: "150",
      },
      {
        key: "已报名：",
        value: "0",
      },
    ],
    tabelData: [
      {
        mc: "培训实战费",
        dw: "人/次",
        bz: "￥299.00",
        nr: "包含三天线下课程、实战账号使用、教材讲义及就业推荐服务。",
      },
    ],
  },
  {
    activityName: "2026“AI+垂直行业”创新创业大赛（北京赛区）",
    baseRemark:
      "响应“AI+”国家行动计划，本届大赛重点征集AI在医疗、教育、制造及零售领域的创新应用方案。优胜项目将获得百万创业基金支持、免费办公场地入驻以及一对一投融资对接服务。大赛邀请行业领军人物担任评委，为创业项目提供全方位的商业诊断与技术指导，助力初创企业快速成长。",
    activityId: "99992",
    catalogueId: "9999",
    catalogueName: "AI·数字智能",
    planNum: "500",
    registerNum: "0",
    registerEndDateStr: "2026年05月20日",
    coverImg:
      "https://file.jycyfww.com/wangchuang/qc/prod/static/img/77b1221550584baba85e0e0c4311fda5.png",
    customModels: [
      {
        key: "报名时间：",
        value: "2026年04月10日 - 2026年05月20日",
      },
      {
        key: "举办时间：",
        value: "2026年06月01日 09:00 - 2026年06月02日 18:00",
      },
      {
        key: "地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：",
        value: "北京市海淀区佰能大厦2层",
      },
      {
        key: "联系电话：",
        value: "010-82696524",
      },
      {
        key: "计划人数：",
        value: "500",
      },
      {
        key: "已报名：",
        value: "0",
      },
    ],
    tabelData: [
      {
        mc: "大赛报名费",
        dw: "人/次",
        bz: "￥100.00",
        nr: "包含初审专家评审费、路演场地租赁费、参赛证书及项目展示位。",
      },
    ],
  },
  {
    activityName: "2026 AIGC视觉创意设计与就业加速工作坊",
    baseRemark:
      "针对设计类专业毕业生，本工作坊深度解析Midjourney、Stable Diffusion等工具在商业插画、UI设计及电商海报中的应用。参与者将现场在导师指导下产出专业级作品集，并获得AI设计师职业规划建议。活动现场设有企业HR直聘区，优秀学员可当场获得面试邀请。",
    activityId: "99993",
    catalogueId: "9999",
    catalogueName: "AI·数字智能",
    planNum: "80",
    registerNum: "0",
    registerEndDateStr: "2026年06月05日",
    coverImg:
      "https://file.jycyfww.com/wangchuang/qc/prod/static/img/892b6b1fa52e48ba8bcdac06da948f33.png",
    customModels: [
      {
        key: "报名时间：",
        value: "2026年05月15日 - 2026年06月05日",
      },
      {
        key: "举办时间：",
        value: "2026年06月10日 13:30 - 17:30",
      },
      {
        key: "地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：",
        value: "北京市海淀区佰能大厦2层",
      },
      {
        key: "联系电话：",
        value: "010-82696524",
      },
      {
        key: "计划人数：",
        value: "80",
      },
      {
        key: "已报名：",
        value: "0",
      },
    ],
    tabelData: [
      {
        mc: "工作坊入场费",
        dw: "人/次",
        bz: "￥199.00",
        nr: "包含工作坊实操指导、专属AI模型包、精美茶歇及就业面试入场券。",
      },
    ],
  },
  {
    activityName: "2026 AI人力资源与招聘策略高层研讨会",
    baseRemark:
      "本研讨会面向企业HRBP及初创团队合伙人，探讨AI如何重塑招聘流程。议题包括：AI简历自动筛选机制、数字人面试的应用场景、AI辅助人才画像建模等。通过资深专家的案例分享，帮助企业利用AI技术提升招聘效率，优化人力成本，在人才竞争中占据先机。",
    activityId: "99994",
    catalogueId: "9999",
    catalogueName: "AI·数字智能",
    planNum: "120",
    registerNum: "0",
    registerEndDateStr: "2026年07月20日",
    coverImg:
      "https://file.jycyfww.com/wangchuang/qc/prod/static/img/933330542b9541febec7279c69e65225.png",
    customModels: [
      {
        key: "报名时间：",
        value: "2026年07月01日 - 2026年07月20日",
      },
      {
        key: "举办时间：",
        value: "2026年08月05日 09:00 - 16:00",
      },
      {
        key: "地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：",
        value: "北京市海淀区佰能大厦2层",
      },
      {
        key: "联系电话：",
        value: "010-82696524",
      },
      {
        key: "计划人数：",
        value: "120",
      },
      {
        key: "已报名：",
        value: "0",
      },
    ],
    tabelData: [
      {
        mc: "研讨会席位费",
        dw: "人/次",
        bz: "￥499.00",
        nr: "包含高端酒店自助午餐、行业深度白皮书、全套PPT课件及人脉晚宴。",
      },
    ],
  },
];
